<template>
    <div>
        <div class="courses">
            <h3>{{ trans('clients.headline.course_assignment') }}</h3>

            <extendable-card-list
                v-model="selectedCourses"
                v-slot="slot"
                :data-can-be-added="this.courses.length > 0"
                data-can-be-deleted
                data-can-be-edited
            >
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <label class="label">{{
                            trans('clients.label.select_course')
                        }}</label>
                        <v-select
                            v-model="slot.data.course"
                            :options="allCourses"
                            class="form-vue-select"
                            :class="[{'form-vue-select--error': validate('selectedCourses.' + slot.index +'.course_id')}]"
                        >
                            <div slot="no-options">
                                {{ trans('vue_select.no_options') }}
                            </div>
                        </v-select>
                        <span class="invalid-feedback" v-if="validate('selectedCourses.' + slot.index +'.course_id')">
                            <strong>{{ validate('selectedCourses.' + slot.index +'.course_id') }}</strong>
                        </span>
                        <input
                            :name="'select[' + slot.index + '][course_id]'"
                            :value="
                                slot.data.course ? slot.data.course.value : 0
                            "
                            hidden
                        />
                    </div>
                    <div
                        class="form-row__col form-row__col--one-half"
                        v-if="slot.data.course"
                    >
                        <label class="label">{{
                            trans('clients.label.select_coursevariation')
                        }}</label>
                        <v-select
                            v-model="slot.data.coursevariation"
                            :options="slot.data.course.variations"
                            class="form-vue-select"
                        >
                            <div slot="no-options">
                                {{ trans('vue_select.no_options') }}
                            </div>
                        </v-select>
                        <input
                            :name="
                                'select[' +
                                slot.index +
                                '][course_variation_id]'
                            "
                            :value="
                                slot.data.coursevariation
                                    ? slot.data.coursevariation.value
                                    : 0
                            "
                            hidden
                        />
                    </div>
                </div>
            </extendable-card-list>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'clientCourseFields',
        event: 'bubbleClientCourseFields',
    },
    props: ['courses', 'formerrors'],

    data() {
        return {
            allCourses: this.courses.map((course) => {
                return {
                    value: course.course_id,
                    label: course.course_title,
                    variations: course.variations.map((coursevar) => {
                        return {
                            value: coursevar.is_default ? null : coursevar.id,
                            label:
                                coursevar.variation_name +
                                (coursevar.is_default
                                    ? ' (' +
                                      this.trans(
                                          'courses.label.default_variation'
                                      ) +
                                      ')'
                                    : ''),
                        };
                    }),
                };
            }),
            selectedCourses: [],
            validationErrors: {},
            showAddButton: true,
        };
    },

    methods: {
        validate(attribute) {
            return this.formerrors[attribute]
                ? this.formerrors[attribute][0]
                : '';
        },
    },

    watch: {
        selectedCourses: {
            handler() {
                this.$emit(
                    'bubbleClientCourseFields',
                    this.selectedCourses
                );
            },
            deep: true,
        },
    },
};
</script>
